
import Ticker from '../svelte/ticker.svelte';

let tickerContainer = document.getElementById("ticker-container");
if (tickerContainer) {
  const app = new Ticker({
    target: tickerContainer,
    props: {
    },
  });
}
